import Setting from "@mapmycustomers/shared/types/Setting";

import OrganizationSetting from "@app/enum/OrganizationSetting";
import UserLocationSettingVisibility from "@app/enum/UserLocationSettingVisibility";
import { isManager, isOwner } from "@app/store/iam/util";
import Iam from "@app/types/Iam";

const isUserLocationLayerAvailable = (me: Iam, settings?: Setting[]): boolean => {
  const visibleSetting = settings?.find(
    ({ key }) => key === OrganizationSetting.USER_LOCATION_VISIBILITY
  );
  if (!visibleSetting) {
    return false;
  }
  const value: UserLocationSettingVisibility = visibleSetting.value;
  if (value === UserLocationSettingVisibility.NONE) {
    return false;
  }
  if (value === UserLocationSettingVisibility.OWNER_MANAGER) {
    return isOwner(me) || isManager(me);
  }
  if (value === UserLocationSettingVisibility.OWNER) {
    return isOwner(me);
  }
  return true;
};

export default isUserLocationLayerAvailable;
